import { useQuery } from '@apollo/client'
import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { GET_ONE_PROCESS_REQUEST_BY_ID } from '../../../../graphql/Catalog/Processes/Requests/ProcessesRequests'
import ContentHeader from '../../../Layout/ContentHeader'
import Loader from '../../../Global/Spinner'
import Box from '../../../Global/Box'
import ProgressBarStatusRequest from '../../../Global/ProgressBarStatusRequest'
import InternalNotesRequest from '../../../Global/InternalNotes/InternalNotesRequest'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import moment from 'moment'
import InternalNotes from '../../../Global/InternalNotes/InternalNotes'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import TimeLines from '../../../Global/TimeLines/TimeLines'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import ModalContent from '../../../Global/ModalContent'
import ModalStatusRequests from './ModalStatus/ModalStatusRequests'
import { GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT } from '../../../../graphql/Catalog/Status/statusRoleVisibility'
import MapPointLocationAddress from '../../../Global/MapPointLocationAddress'

const ManageRequestsNew = () => {
  const refModal = useRef(null)
  const { id: _id } = useParams()
  const history = useHistory()

  const [dataRequest, setDataRequest] = useState(null)
  const [isEditingMarkerPosition, setIsEditingMarkerPosition] = useState({
    lat: null,
    lng: null,
  })
  const [reftechNotes, setReftechNotes] = useState(false)
  const [closeModal, setCloseModal] = useState(false)
  const [statusOfRole, setStatusOfRole] = useState([])
  const [modalContent, setModalContent] = useState({
    title: '',
    content: null,
    size: 'extra',
    modalId: null,
  })

  const { loading, error, data, refetch } = useQuery(
    GET_ONE_PROCESS_REQUEST_BY_ID,
    {
      variables: {
        getProcessRequestByIdId: +_id,
      },
      fetchPolicy: 'no-cache',
    }
  )

  const {
    data: dataStatusRole,
    loading: loadingStatusRole,
    error: errorStatusRole,
  } = useQuery(GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT, {
    variables: {
      type_status: 'process',
    },
  })
  useEffect(() => {
    try {
      if (loading) return
      if (error)
        return (
          toastSweetAlert({
            mode: 'errorToast',
            message: error.message,
          }),
          history.push('/managerequests')
        )

      setDataRequest(data.getProcessRequestById)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  useEffect(() => {
    if (dataRequest) {
      if (dataRequest?.ProcessesRequestsToCitizens?.coordinates) {
        const [lat, lng] =
          dataRequest?.ProcessesRequestsToCitizens?.coordinates?.split(',')
        setIsEditingMarkerPosition({
          lat: lat ? parseFloat(lat) : null,
          lng: lng ? parseFloat(lng) : null,
        })
      }
    }
  }, [dataRequest])

  useEffect(() => {
    if (!loadingStatusRole && !errorStatusRole) {
      if (dataStatusRole) {
        setStatusOfRole(
          dataStatusRole.getAllStatusRoleByTypeStatusOfUserContext
        )
      }
    }
  }, [dataStatusRole, loadingStatusRole, errorStatusRole])

  useEffect(() => {
    if (modalContent.modalId) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
    }
  }, [modalContent])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
      setReftechNotes(!reftechNotes)
      setModalContent({
        title: '',
        content: null,
        modalId: null,
        size: 'extra',
      })

      setCloseModal(false)
      setTimeout(() => {
        setReftechNotes(!reftechNotes)
      }, 500)
    }
  }, [closeModal])

  const foundStatusCurrentInStatusRole = (status_id) => {
    return statusOfRole.find((item) => item.status_id === status_id)
  }

  const handleProcess = (id, row) => {
    setModalContent({
      title: `Procesar solicitud ${row.folio}`,
      content: (
        <>
          <ModalStatusRequests
            requestId={id}
            currentStatusId={row?.ProcessesRequestsToStatus?.id}
            reportFolio={row?.folio}
            externalFolio={row?.external_folio}
            groupCategory={row?.ProcessesRequestsToCategories?.name}
            currentStatusName={row?.ProcessesRequestsToStatus?.name}
            setCloseModal={setCloseModal}
            refetchMain={refetch}
            maxFiles={3}
            // FilesRequirements={documentsRequirements}
          />
        </>
      ),
      modalId: 'modalStatusRequests',
      size: 'large',
    })
  }

  return (
    <>
      {loading || !dataRequest ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <>
          <ContentHeader
            title=""
            titleContent={
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <div>
                    <Link
                      className="btn btn-migrates-white mb-3"
                      to={`/managerequests`}
                    >
                      <i className="fas fa-long-arrow-alt-left" /> Atrás
                    </Link>
                    <h1 className="header-title">{`Detalles trámite - ${
                      dataRequest ? dataRequest.folio : ''
                    }`}</h1>
                  </div>
                </div>
              </div>
            }
            windowTitle="Solicitud de trámite"
            breadcrumb=""
          />

          <div className="row manage-new-container">
            {/**------- LEFT SECTION ------- */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 left-box">
              <div className="row">
                <div className="col-12">
                  <div className="reports">
                    <Box
                      classNameHeader="card-header py-1"
                      contentHeader={
                        <>
                          <h3 className="card-title pl-3 mt-0">
                            Datos generales
                          </h3>
                          <div className={`card-tools mr-2`}>
                            <div
                              style={{ fontSize: 13 }}
                              className={` px-2 rounded`}
                            >
                              <b className="mr-1" style={{ fontSize: 10 }}>
                                {/*Estatus:*/}
                                {/* <ProgressBarStatusRequest
                                  // showTitle
                                  statusIdRequest={
                                    dataRequest.ProcessesRequestsToStatus.id
                                  }
                                /> */}

                                <ProgressBarStatusReport
                                  statusReport={
                                    dataRequest.ProcessesRequestsToStatus
                                  }
                                />
                                {foundStatusCurrentInStatusRole(
                                  dataRequest.status_id
                                ) && (
                                  <button
                                    className="btn btn-migrates btn-sm mr-2"
                                    onClick={() =>
                                      handleProcess(dataRequest.id, dataRequest)
                                    }
                                  >
                                    Procesar
                                  </button>
                                )}
                              </b>
                            </div>
                          </div>
                        </>
                      }
                      content={
                        <div className="row">
                          {dataRequest?.request_date && (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                              <span className="title-details">
                                Fecha de solicitud
                              </span>
                              <br />
                              <span className="content-details">
                                {moment(
                                  Number(dataRequest.request_date)
                                ).format('DD/MM/YYYY') +
                                  ', ' +
                                  moment(
                                    Number(dataRequest.request_date)
                                  ).format('LT') || '--'}
                              </span>
                            </div>
                          )}
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">
                              Fecha de entrega
                            </span>
                            <br />
                            <span className="content-details">
                              {dataRequest.request_date_end ? (
                                <>
                                  {moment(dataRequest.delivery_date).format(
                                    'DD/MM/YYYY'
                                  ) +
                                    ', ' +
                                    moment(dataRequest.delivery_date).format(
                                      'LT'
                                    ) || '--'}
                                </>
                              ) : (
                                <>Aún no se ha finalizado</>
                              )}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Folio</span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.folio || 'N/A'}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Folio Externo</span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.external_folio || 'N/A'}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Proceso</span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.ProcessesRequestsToProcesses
                                ?.name || 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Dependencias</span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.ProcessesRequestsToCategories
                                ?.name || 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">
                              Tipo de trámite
                            </span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.ProcessesRequestsToSubCategories
                                ?.name || 'N/A'}
                            </span>
                          </div>
                          {/* {dataRequest?.ProcessesRequestToSubCategoriesChildren && ( */}
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Subcategoría</span>
                            <br />
                            <span className="content-details">
                              {dataRequest
                                ?.ProcessesRequestToSubCategoriesChildren
                                ?.name || 'N/A'}
                            </span>
                          </div>
                          {/* )} */}
                        </div>
                      }
                    />
                  </div>
                </div>

                {dataRequest.ProcessesRequestsToProcesses.key ===
                  'processes_geo' && (
                  <div className="col-12 reports">
                    <Box
                      title="Ubicación del ciudadano"
                      classNameHeader="card-header py-1"
                      content={
                        <div className="row">
                          <div className="col-12">
                            {/* <GoogleMapComponent
                              showInputAutocomplete={false}
                              isEditingMarkerPosition={isEditingMarkerPosition}
                            /> */}
                            {isEditingMarkerPosition?.lat &&
                              isEditingMarkerPosition?.lng && (
                                <div className="col-12">
                                  <MapPointLocationAddress
                                    latitude={isEditingMarkerPosition?.lat}
                                    longitude={isEditingMarkerPosition?.lng}
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      }
                    />
                  </div>
                )}

                <div className="col-12 reports">
                  <ReportAttachments
                    attachments={dataRequest?.ProcessesRequestToAttachments}
                  />
                </div>

                <div className="col-12">
                  <div className="reports">
                    <Box
                      title="Información del ciudadano"
                      classNameHeader="card-header py-1"
                      content={
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Nombre</span>
                            <br />
                            <span className="content-details">
                              {`${dataRequest?.ProcessesRequestsToCitizens?.name} ${dataRequest?.ProcessesRequestsToCitizens?.last_name}`}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Email</span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.ProcessesRequestsToCitizens
                                ?.email || 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Teléfono</span>
                            <br />
                            <span className="content-details">
                              {dataRequest?.ProcessesRequestsToCitizens
                                ?.phone || 'N/A'}
                            </span>
                          </div>

                          {dataRequest.ProcessesRequestsToProcesses.key ===
                            'processes_geo' && (
                            <>
                              <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                                <span className="title-details">Dirección</span>
                                <br />
                                <span className="content-details">
                                  {dataRequest?.ProcessesRequestsToCitizens
                                    ?.address_full || 'N/A'}
                                </span>
                              </div>
                              <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                                <span className="title-details">
                                  Dirección manual
                                </span>
                                <br />
                                <span className="content-details">
                                  {dataRequest?.ProcessesRequestsToCitizens
                                    ?.address || 'N/A'}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            {/**------- RIGHT SECTION ------- */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 right-box">
              <div className="row">
                <div className="col-12">
                  <InternalNotes
                    category_note={'process'}
                    category_notes_status={'process_status'}
                    document_id={_id ? parseInt(_id) : 0}
                    flagSwitchInternalMode={false}
                    refetchNotes={reftechNotes}
                  />
                </div>
                <div className="col-12">
                  <TimeLines document_id={parseInt(_id)} category="process" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <span
        id={`spanModal${modalContent.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalContent.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModal}
      />

      <ModalContent
        idModal={modalContent.modalId}
        title={modalContent.title}
        size={modalContent.size}
        onClose={() => {
          setModalContent({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })
        }}
        content={modalContent.content}
      />
    </>
  )
}

const ReportAttachments = ({ attachments }) => {
  const MySwal = withReactContent(Swal)
  const [uniqueUser, setUniqueUser] = useState([])

  useEffect(() => {
    if (attachments) {
      const uniqueUsers = attachments.reduce((acc, attachment) => {
        if (
          !acc.some(
            (user) =>
              user?.user_id === attachment?.UserOfProcessRequestAttachment?.id
          )
        ) {
          acc.push({
            user_id: attachment?.UserOfProcessRequestAttachment?.id,
            user: attachment.UserOfProcessRequestAttachment,
          })
        }
        return acc
      }, [])
      setUniqueUser(uniqueUsers)
    }
  }, [attachments])

  const switchFile = (type_file) => {
    const data = {
      pdf: {
        icon: 'fas fa-file-pdf',
        text: 'PDF',
      },
      img: {
        icon: 'fas fa-image',
        text: 'IMG',
      },
      png: {
        icon: 'fas fa-image',
        text: 'IMG',
      },
      jpg: {
        icon: 'fas fa-image',
        text: 'IMG',
      },
      jpeg: {
        icon: 'fas fa-image',
        text: 'IMG',
      },
    }
    return (
      <>
        {data[type_file ? type_file : 'img']?.text}
        <i
          className={`${data[type_file ? type_file : 'img'].icon} fa-2x ml-2`}
        />
      </>
    )
  }

  const handleModalImage = (url) => {
    MySwal.fire({
      // title: "Sweet!",
      // text: "Modal with a custom image.",
      imageUrl: url,
      imageWidth: 500,
      imageHeight: 440,
      // imageAlt: "Custom image"
      buttonsStyling: false,
      confirmButtonText: 'Aceptar',
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    })
  }

  return (
    <Box
      title="Archivos adjuntos"
      classNameHeader="card-header py-1"
      content={
        <>
          {attachments?.length === 0 ? (
            'No hay archivos adjuntos'
          ) : (
            <div className="d-flex flex-wrap row">
              {uniqueUser.map((user) => {
                let findAttachment = attachments.filter((value) => {
                  return (
                    value?.UserOfProcessRequestAttachment?.id == user.user_id
                  )
                })
                if (findAttachment.length > 0) {
                  return (
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                      <span
                        className="title-details"
                        style={{ width: '100%' }}
                      >{`${user.user?.name} ${
                        user?.user?.name &&
                        `(${user?.user?.RoleOfUser?.role_name})`
                      }`}</span>
                      <br />
                      {findAttachment.map((attachment) => {
                        if (!attachment?.url) {
                          return null
                        }

                        return (
                          <div key={attachment.id} className="btn btn-light">
                            {attachment?.type_file === 'img' ? (
                              <a
                                className="link-primary documentLink"
                                style={{ textDecoration: 'none' }}
                                as="button"
                                title="Descargar"
                                onClick={() => handleModalImage(attachment.url)}
                              >
                                {switchFile(attachment?.type_file)}
                              </a>
                            ) : (
                              <a
                                className="link-primary documentLink"
                                style={{ textDecoration: 'none' }}
                                as="button"
                                href={attachment.url}
                                target="_blank"
                                rel="noreferrer"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Descargar"
                              >
                                {switchFile(attachment?.type_file)}
                              </a>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )
                }
                return null
              })}
            </div>
          )}
        </>
      }
    />
  )
}

export default ManageRequestsNew
